
const ProductIcon = () => {
    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.5" width="24" height="24" rx="8" fill="#F2F4F7" />
            <path d="M16.5 10.5002C16.4998 10.3248 16.4535 10.1526 16.3658 10.0008C16.278 9.84895 16.1519 9.72288 16 9.6352L12.5 7.6352C12.348 7.54743 12.1755 7.50122 12 7.50122C11.8245 7.50122 11.652 7.54743 11.5 7.6352L8 9.6352C7.84813 9.72288 7.72199 9.84895 7.63423 10.0008C7.54647 10.1526 7.50018 10.3248 7.5 10.5002V14.5002C7.50018 14.6756 7.54647 14.8478 7.63423 14.9996C7.72199 15.1514 7.84813 15.2775 8 15.3652L11.5 17.3652C11.652 17.453 11.8245 17.4992 12 17.4992C12.1755 17.4992 12.348 17.453 12.5 17.3652L16 15.3652C16.1519 15.2775 16.278 15.1514 16.3658 14.9996C16.4535 14.8478 16.4998 14.6756 16.5 14.5002V10.5002Z" stroke="#475467" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.6499 10.0002L11.9999 12.5002L16.3499 10.0002" stroke="#475467" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 17.5V12.5" stroke="#475467" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default ProductIcon
